import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// import { styled } from '@mui/material/styles';

import { MyPageHead } from "../common/index";

import { MypageWrapper } from "../common/style";

import defaultProfile from "../../../../assets/images/icons/default-profile.svg";
import photoBtn from "../../../../assets/images/icons/photo-btn.svg";

import { area } from "./area";
import { UserCreators } from "redux/modules/user";
import { useNavigate } from "react-router-dom";

function UpdateInfo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isEditDone = useSelector((state) => state.user.isEditDone);

  const fileInput = React.useRef(null);

  const oriImage = localStorage.getItem("profileImage");
  const oriNickname = localStorage.getItem("nickname");
  const oriCity = localStorage.getItem("city");
  const oriRegion = localStorage.getItem("region");
  const oriAnnual = localStorage.getItem("annual");

  const [image, setImage] = useState(`${oriImage}`);
  const [file, setFile] = useState("");
  const [nickname, setNickname] = useState(`${oriNickname}`);
  // const [imageSrc, setImageSrc] = useState(`${oriImage}`);
  const [annual, setAnnual] = useState(`${oriAnnual}`);
  const [city, setCity] = useState(`${oriCity}`);
  const [regionList, setRegionList] = useState([]);
  const [region, setRegion] = useState(`${oriRegion}`);
  const [isDisabled, setDisabled] = useState(true);

  useEffect(() => {
    // 프로필 사진 없을때 값 확인하기
    if (oriImage === undefined) {
      setImage(defaultProfile);
    }
    dispatch(UserCreators.getUserInfos());
    const temp = area.filter((value) => value.cities === city);
    setRegionList(temp[0].regions);
  }, [isEditDone]);

  const updateImgHandler = () => {
    fileInput.current.click();
  };

  const handleImgChange = (e) => {
    console.log(e.target.files[0]);
    setFile(e.target.files[0]);
    setDisabled(false);
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    return new Promise((resolve) => {
      reader.onload = () => {
        setImage(reader.result);
        resolve();
      };
    });
  };

  const handleNicknameChange = (e) => {
    setNickname(e.target.value);
    setDisabled(false);
  };

  const handleAnnualChange = (e) => {
    setAnnual(e.target.value.replace(/[^0-9]/g, ""));
    setDisabled(false);
  };

  const handleSelectCityChange = (e) => {
    setCity(e.target.value);
    const temp = area.filter((value) => value.cities === e.target.value);
    setRegionList(temp[0].regions);
    setRegion("");
    setDisabled(false);
  };

  const handleSelectRegionChange = (e) => {
    setRegion(e.target.value);
    setDisabled(false);
  };

  const continueBtnHandler = () => {
    const formdata = new FormData();
    formdata.append("nickname", nickname);
    formdata.append("profileImage", file);
    formdata.append("annual", annual);
    formdata.append("city", city);
    formdata.append("region", region);
    dispatch(UserCreators.putProfile(formdata));
    navigate("/mypage");
  };

  // validator 따로 작업해서 버튼에 disabled 걸기(연차에 숫자 외 입력하면 disabled 추가)

  return (
    <MypageWrapper>
      <MyPageHead title="프로필 수정" />

      <ProfileContainer onClick={updateImgHandler}>
        <Imgbox>
          <ProfileImg src={image} />
        </Imgbox>
        <Imgbtn src={photoBtn} />
        <input
          type="file"
          ref={fileInput}
          onChange={handleImgChange}
          style={{ display: "none" }}
        />
      </ProfileContainer>
      <InputContainer>
        <InputEach>
          <InputTitle>닉네임</InputTitle>
          <LongInput
            placeholder="변경하실 닉네임을 입력해 주세요"
            onChange={handleNicknameChange}
          />
        </InputEach>
        <InputEach>
          <InputTitle>연차</InputTitle>
          <LongInput
            placeholder="연차(숫자만)를 입력해 주세요"
            onChange={handleAnnualChange}
          />
        </InputEach>
        <InputEach>
          <InputTitle>지역</InputTitle>
          <SelectContainer>
            <FormControl
              sx={{
                m: 0,
                width: 152,
                bgcolor: "#F1F3F5",
                border: 0,
              }}
              size="small"
            >
              <CustomizedSelect
                value={city}
                onChange={handleSelectCityChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                {area.map((value) => (
                  <MenuItem value={value.cities} sx={{ fontSize: 13 }}>
                    {value.cities}
                  </MenuItem>
                ))}
              </CustomizedSelect>
            </FormControl>
            <FormControl
              sx={{
                width: 152,
                bgcolor: "#F1F3F5",
              }}
              size="small"
            >
              <CustomizedSelect
                value={region}
                onChange={handleSelectRegionChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                {regionList.map((value) => (
                  <MenuItem value={value} sx={{ fontSize: 13 }}>
                    {value}
                  </MenuItem>
                ))}
              </CustomizedSelect>
            </FormControl>
          </SelectContainer>
        </InputEach>
      </InputContainer>
      <ContinueBtn
        onClick={continueBtnHandler}
        disabled={
          isDisabled ||
          nickname === "" ||
          city === "" ||
          region === "" ||
          annual === ""
        }
      >
        완료
      </ContinueBtn>
    </MypageWrapper>
  );
}

export default UpdateInfo;

const ProfileContainer = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  margin: 50px auto 30px;
`;

const Imgbox = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 70%;
  overflow: hidden;
`;

const ProfileImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Imgbtn = styled.img`
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 24px;
  height: 24px;
`;

const InputContainer = styled.div``;

const InputEach = styled.div`
  width: 285px;
  margin-bottom: 20px;
`;
const SelectContainer = styled.div`
  margin-top: 5px;
  width: 315px;
  display: flex;
  justify-content: space-between;
`;

const InputTitle = styled.span`
  height: 21px;
  font-size: 13px;
  font-weight: bold;
`;

const LongInput = styled.input`
  margin-top: 5px;
  width: 285px;
  height: 44px;
  border-radius: 8px;
  border: none;
  background-color: #f1f3f5;
  padding: 0px 15px;
  &:focus {
    outline: none;
  }
`;

const ContinueBtn = styled.button`
  background-color: #ff7a00;
  height: 50px;
  width: 100%;
  border: 0;
  outline: 0;
  color: white;
  margin-top: 100px;
  &:disabled {
    background-color: lightgray;
    color: gray;
  }
`;

const CustomizedSelect = styled(Select)`
  & .MuiSelect-select {
    font-size: 13px;
  }
  & .MuiSelect-multiple {
    border: 2px solid red;
  }
`;

const CustomizedMenuItem = styled(MenuItem)`
  & .MuiMenuItem-root {
    font-size: 13px;
  }
  & .Mui-selected {
    font-size: 13px;
  }
`;
